module.exports = __webpack_public_path__ + "media/images/categories/icon_cat17-1220ef448745825d8fb951a44e58321a.svg";